import { Form, Table } from "react-bootstrap";
import { useState } from "react";
import AddTag from "./AddTag";
import UpdateTag from "./UpdateTag";
import Moment from "react-moment";
import { useEffect } from "react";
import Swal from "sweetalert2";
import UseToggle from "../../../../../Hooks/UseToggle";
import ToolBar from "../../../../Componant/ToolBar";
import { storeTagServices } from "../../../../../APIServices/SitePilotManagement/StoreManagement/storeTagServices";

const TagManagement = ({getActiveStoreTagList}) => {
  const toggles = UseToggle();
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [storeCategories, setStoreCategories] = useState([]);
  const [storeTagData, setStoreTagData] = useState("");
  const [storeTagCount, setStoreTagCount] = useState(0);
  const [storeTagIds, setStoreTagIds] = useState([]);

  const toggleSingle = (id) => {
    setStoreTagIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const toggleAll = () => {
    if (storeTagIds.length === storeCategories.length) {
      setStoreTagIds([]);
    } else {
      setStoreTagIds(storeCategories.map((c) => c.id));
    }
  };

  const isAllChecked =
    storeCategories.length > 0 && storeTagIds.length === storeCategories.length;
  const isChecked = (id) => storeTagIds.includes(id);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = Math.ceil(storeTagCount / itemsPerPage);

  const start = (pageNumber - 1) * itemsPerPage + 1;
  const end = Math.min(pageNumber * itemsPerPage, storeTagCount);

  const getStoreTagList = async () => {
    setLoader(true);
    let data = await storeTagServices.getStoreTagList(
      "all",
      search,
      pageNumber,
      itemsPerPage,
    );
    setStoreCategories(data?.data || []);
    setStoreTagCount(data?.count || 0);
    setLoader(false);
  };

  const updatedStoreTag = async (categoryId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${status} this Store Tag?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.categoryId = categoryId;
        userData.status = status;
        let data = await storeTagServices.updatedStoreTag(userData);
        if (data?.statusCode === 200) {
          getActiveStoreTagList();
          getStoreTagList();
        }
      }
    });
  };

  const deleteStoreTag = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this Store Tag?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.categoryIds = storeTagIds;
        let data = await storeTagServices.deleteStoreTag(userData);
        if (data?.statusCode === 200) {
          getActiveStoreTagList();
          getStoreTagList();
        }
      }
    });
  };

  useEffect(() => {
    let storeTagData = storeCategories?.find(
      (item) => item.categoryId === storeTagIds?.[0],
    );
    setStoreTagData(storeTagData || "");
  }, [storeTagIds]);

  useEffect(() => {
    getStoreTagList();
  }, [search, pageNumber, itemsPerPage]);

  return (
    <>
      <ToolBar
        toggles={toggles}
        search={search}
        setSearch={setSearch}
        checkedIds={storeTagIds}
        setCheckedIds={setStoreTagIds}
        start={start}
        end={end}
        totalItems={storeTagCount}
        page={pageNumber}
        setPage={setPageNumber}
        setPageSize={setItemsPerPage}
        pageSize={itemsPerPage}
        totalPages={totalPages}
        deleteData={deleteStoreTag}
        addField
        editField
      />
      <div className={`contacts-layout`}>
        <div
          className={`table-section overflow-auto bg-white `}
          style={{ height: "calc(100vh - 153px)" }}
        >
          <Table
            hover
            className="contacts-table mb-0"
            style={{ verticalAlign: "middle" }}
          >
            <thead>
              <tr>
                <th>
                  <div className="d-flex align-items-center gap-2">
                    <div className="px-2">
                      <Form.Check
                        type="checkbox"
                        checked={isAllChecked}
                        onChange={toggleAll}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                    <div>Tags</div>
                  </div>
                </th>
                <th>Total Post</th>
                <th>Status</th>
                <th>Created Date | Time</th>
                <th>Updated Date | Time</th>
              </tr>
            </thead>
            <tbody>
              {storeCategories?.map((item) => (
                <tr key={item.categoryId}>
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <div className="px-2">
                        <Form.Check
                          type="checkbox"
                          checked={isChecked(item.categoryId)}
                          onChange={() => toggleSingle(item.categoryId)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div>
                        <div className="fw-medium">{item.name}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span className="fw-medium">{item.totalPost || 0}</span>
                  </td>
                  <td>
                    <Form.Check
                      type="switch"
                      onChange={() =>
                        updatedStoreTag(
                          item?.categoryId,
                          item.status === "active" ? "inactive" : "active",
                        )
                      }
                      checked={item.status === "active"}
                    />
                  </td>
                  <td>
                    <span className="fw-medium">
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item?.createdAt}
                      </Moment>
                    </span>
                  </td>
                  <td>
                    <span className="fw-medium">
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item?.updatedAt}
                      </Moment>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
      <AddTag
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        title={`Add Tag`}
        getStoreTagList={getStoreTagList}
        getActiveStoreTagList={getActiveStoreTagList}
      />
      <UpdateTag
        show={!toggles.toggle1}
        hide={() => toggles.setToggle1()}
        title={`Update Tag`}
        storeTagData={storeTagData}
        setStoreTagData={setStoreTagData}
        setStoreTagIds={setStoreTagIds}
        getStoreTagList={getStoreTagList}
        getActiveStoreTagList={getActiveStoreTagList}
      />
    </>
  );
};

export default TagManagement;
